import { render, staticRenderFns } from "./VgField.vue?vue&type=template&id=a4c9e5f6&scoped=true&"
import script from "./VgField.vue?vue&type=script&lang=js&"
export * from "./VgField.vue?vue&type=script&lang=js&"
import style0 from "./VgField.vue?vue&type=style&index=0&id=a4c9e5f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c9e5f6",
  null
  
)

export default component.exports